export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/saveDepositProof`,
                method: 'POST',
                body: payload
            };
        },
        invalidatesTags: ['allCashDepositRecordByAgent'] 

    })
